import Vue from 'vue';
import dayjs from 'dayjs';

// 全局属性挂载
Vue.prototype.$dayjs = dayjs;
